module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modal",
    attrs: {
      "visible": "",
      "size": "lg",
      "hide-footer": true,
      "title": "Productdetails"
    },
    on: {
      "hidden": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header block-header-default",
    staticStyle: {
      "display": "block"
    }
  }, [_c('h6', [_vm._v("Voer onderstaande gegevens in om het product in te boeken of sluit dit scherm")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('form', {
    attrs: {
      "onsubmit": "return false"
    }
  }, [_c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "Barcode"
    }
  }, [_vm._v("Barcode:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.barcode),
      expression: "barcode"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "type": "text",
      "id": "Barcode"
    },
    domProps: {
      "value": (_vm.barcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.barcode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "Location"
    }
  }, [_vm._v("Locatie:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productLocation),
      expression: "productLocation"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "type": "text",
      "id": "Location",
      "placeholder": "A.01.01.01.01"
    },
    domProps: {
      "value": (_vm.productLocation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.productLocation = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "ProductTitle"
    }
  }, [_vm._v("ProductTitel:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productTitle),
      expression: "productTitle"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "type": "text",
      "id": "ProductTitle",
      "placeholder": "Washandje rood"
    },
    domProps: {
      "value": (_vm.productTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.productTitle = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "Quantity"
    }
  }, [_vm._v("Aantal:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productQuantity),
      expression: "productQuantity"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "type": "number",
      "id": "Quantity",
      "placeholder": "6"
    },
    domProps: {
      "value": (_vm.productQuantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.productQuantity = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "Brand"
    }
  }, [_vm._v("Bestaande Merk:")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.brands,
      "placeholder": "Selecteer een leverancier",
      "selected-label": "✔",
      "select-label": "",
      "deselect-label": "✔",
      "allow-input": ""
    },
    model: {
      value: (_vm.productBrand),
      callback: function($$v) {
        _vm.productBrand = $$v
      },
      expression: "productBrand"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "newBrand"
    }
  }, [_vm._v("Nieuwe merk:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newBrand),
      expression: "newBrand"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "type": "text",
      "id": "newBrand",
      "placeholder": "Coca cola"
    },
    domProps: {
      "value": (_vm.newBrand)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newBrand = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.createProduct
    }
  }, [_vm._v("Opslaan")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d13423a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/products/UnkownProductModal.vue
// module id = 707
// module chunks = 1